<div class="user-avatar {{size}}" [ngClass]="color">
  @if (avatarImageUrl) {
    <img src="{{avatarImageUrl}}" alt="avatar" class="rounded-circle">
  } @else {
    {{firstInitial}}{{lastInitial}}
  }
</div>